<template>
  <div class="carousel-first">
    <div class="first-content">
      <el-carousel style="height: 100%" height="100%" @change="carouselChange">
        <el-carousel-item v-for="(item, index) in carouselList" :key="index">
          <div
            class="carousel-content"
            :style="{ backgroundImage: 'url(' + item.background + ')' }"
          ></div>
        </el-carousel-item>
      </el-carousel>
      <!-- 江郎山-廿八都旅游区介绍  -->
      <div class="scenery-introduce">
        <div class="introduce-title">
          <img
            v-if="!$t('index.firstTitle')"
            class="title-img"
            src="@/assets/images/index/first/introduce/title.png"
          />
          {{ $t("index.firstTitle") }}
        </div>
        {{ $t("index.firstTips") }}
        <div class="img-tag">
          <img
            class="UNESCO"
            src="@/assets/images/index/first/introduce/UNESCO.png"
          />
          <img
            class="word-heritage"
            src="@/assets/images/index/first/introduce/word-heritage.png"
          />
          <img
            class="national-of-china"
            src="@/assets/images/index/first/introduce/national-of-china.png"
          />
          <img
            class="AAAAA"
            src="@/assets/images/index/first/introduce/AAAAA.png"
          />
        </div>
      </div>
      <!-- 下方景区数据 -->
      <div class="first-panel">
        <div v-for="(item, index) in panelList" :key="index" class="panel-item">
          <div class="flex-sub flex flex-direction align-center justify-center">
            <img
              v-if="index === 0"
              class="Nianbadu-icon"
              src="@/assets/images/index/Nianbadu.png"
            />
            <img
              v-if="index === 1"
              class="Qingyang-icon"
              src="@/assets/images/index/Qingyang.png"
            />
            <img
              v-if="index === 2"
              class="Jianglang-icon"
              src="@/assets/images/index/Jianglang.png"
            />
            <div class="panel-label">
              {{ $t("ajaxKey") ? item[$t("ajaxKey")] : item.placeName }}
            </div>
          </div>
          <div class="flex-sub flex flex-direction align-center justify-center">
            <div class="panel-value">{{ item.scenicMaxNum }}</div>
            <div class="panel-label">{{ $t("scenery.load") }}</div>
          </div>
          <div class="flex-sub flex flex-direction align-center justify-center">
            <div class="panel-value">{{ item.scenicTimeMaxNum }}</div>
            <div class="panel-label">{{ $t("scenery.instantaneousLoad") }}</div>
          </div>
          <div class="flex-sub flex flex-direction align-center justify-center">
            <div class="panel-value">{{ item.personTimeNum }}</div>
            <div class="panel-label">{{ $t("scenery.people") }}</div>
          </div>
        </div>
      </div>
    </div>

    <footer-content></footer-content>
  </div>
</template>

<script>
import { getPassengnum } from "@/api/index";
import footerContent from "@/components/footer.vue";
export default {
  components: { footerContent },
  props: {
    carouselFirstIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      carouselList: [
        {
          background: require("@/assets/images/index/first/Jianglang-background.jpg"),
        },
        {
          background: require("@/assets/images/index/first/Nianbadu-backgournd.jpg"),
        },
        {
          background: require("@/assets/images/index/first/Qingyang-background.jpg"),
        },
      ],

      panelList: [],
    };
  },
  created() {
    getPassengnum().then((res) => {
      this.panelList = res.data.records;
    });
  },
  methods: {
    carouselChange(index) {
      this.$emit("update:carouselFirstIndex", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-first {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .first-content {
    flex: 1;
    position: relative;
    ::v-deep {
      .el-carousel__arrow {
        display: none;
      }
      .el-carousel__indicators--horizontal {
        bottom: 150px;
        .el-carousel__indicator--horizontal {
          .el-carousel__button {
            width: 10px;
            height: 10px;
            background-color: transparent;
            border-radius: 5px;
            border: 1px solid #ffffff;
            opacity: 1;
          }
          &.is-active {
            .el-carousel__button {
              background: #ffffff;
            }
          }
        }
      }
    }
    .carousel-content {
      height: 100%;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .scenery-introduce {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1200px;
      z-index: 2;
      transform: translate(-50%, -50%);
      box-sizing: border-box;

      padding: 60px 40px 20px 40px;
      border-radius: 2px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.3) 0%,
        rgba(255, 255, 255, 0) 100%
      );

      color: #fff;
      text-align: center;
      font-size: 19px;
      font-weight: 400;
      line-height: 30px; /* 157.895% */
      .introduce-title {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);

        color: #fff;
        white-space: nowrap;
        font-size: 58px;
        font-weight: 400;
        line-height: 30px; /* 51.724% */
        .title-img {
          width: 700px;
          display: block;
        }
      }
      .img-tag {
        position: absolute;
        bottom: -16px;
        left: 50%;
        transform: translate(-50%, 100%);
        display: flex;
        align-items: center;
        .UNESCO {
          width: 64px;
        }
        .word-heritage {
          width: 58.5px;
        }
        .national-of-china {
          width: 56.5px;
        }
        .AAAAA {
          width: 75px;
        }
        img {
          display: block;
          + img {
            margin-left: 17px;
          }
        }
      }
    }

    .first-panel {
      position: absolute;
      width: 100%;
      padding: 16px 200px;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      z-index: 2;
      bottom: 0;
      .panel-item {
        padding: 17px 0;
        flex: 1;
        background-image: url(@/assets/images/index/panel-background.png);
        border-radius: 6px;
        background-repeat: no-repeat;
        background-size: 100%;
        box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
        display: flex;
        .Nianbadu-icon {
          display: block;
          width: 43px;
          height: 40px;
        }
        .Qingyang-icon {
          display: block;
          width: 40.5px;
          height: 40px;
        }
        .Jianglang-icon {
          display: block;
          width: 40.5px;
          height: 40px;
        }
        .panel-value {
          color: #fff;
          font-size: 20px;
          font-weight: 700;
        }
        .panel-label {
          margin-top: 7px;
          color: #fff;
          font-size: 14px;
          font-weight: 400;
          text-align: center;
        }
        + .panel-item {
          margin-left: 24px;
        }
        &:nth-of-type(1) {
          background-color: #037360;
        }
        &:nth-of-type(2) {
          background-color: #0b496d;
        }
        &:nth-of-type(3) {
          background-color: #606a3e;
        }
      }
    }
  }
}
</style>
